// 曝瓜网 · 证据类静态数据

export const timelineData = [
  {
    time: "09-05 23:10",
    mark: "反转",
    title: "绩效罗生门再添第三批群聊：考勤口径与月结单存在多版本",
    summary: "新流出群聊显示同一月考勤先后存在两套导出口径，双方均晒出后台截图，时间戳仅相差 6 分钟。",
    evidence: ["群聊 3 段", "后台截图 4 张"],
    heat: "评论破万",
  },
  {
    time: "09-05 21:02",
    mark: "录音",
    title: "52 秒返点录音逐句转写完成，关键数字与报价单吻合",
    summary: "曝瓜网将录音降噪转写并与已晒报价单逐行核对，返点数额在多处对得上，待对方原声比对。",
    evidence: ["转写稿", "降噪原声"],
    heat: "冲上热榜",
  },
  {
    time: "09-05 18:40",
    mark: "石锤",
    title: "「假一赔十」货不对板：批次断档时间线已完整拼出",
    summary: "47 张面单与 12 份抽检底单串成时间线，同 SKU 批次号存在两段断档，指向非同一产线。",
    evidence: ["底单 12 份", "面单 47 张"],
    heat: "石锤确认",
  },
  {
    time: "09-05 16:15",
    mark: "新流出",
    title: "选品报价单四档佣金流出，同款商品价差引发集中质疑",
    summary: "一张标注「内部勿传」的报价表被晒出，同款不同档报价最大差距超过两倍。",
    evidence: ["报价表 1 份"],
    heat: "争议中",
  },
  {
    time: "09-05 12:30",
    mark: "跟进",
    title: "涉事直播基地晚间声明称「截图系拼接」，晒出平台存证编号",
    summary: "声明附上平台数据存证编号，曝瓜网已锁定编号并同步调取公开接口做一致性校验。",
    evidence: ["存证编号"],
    heat: "等回应",
  },
  {
    time: "09-05 09:08",
    mark: "图证",
    title: "朴造餐饮后厨监控截图补充三张，网友逐帧比对灶台布局",
    summary: "新增监控截图指向深夜加班的操作台状态，评论区已有人用公开门面图做角度比对。",
    evidence: ["监控图 3 张"],
    heat: "图文并进",
  },
  {
    time: "09-04 22:55",
    mark: "辟谣",
    title: "「主播塌房」造谣帖已核删：同批号聊天记录系旧图重发",
    summary: "比对水印时间与公开旧帖后确认同段记录曾于半年前出现，已标记为历史重复图。",
    evidence: ["重复比对"],
    heat: "已标记",
  },
  {
    time: "09-04 19:20",
    mark: "录音",
    title: "成分表争议现场 40 秒原声流出：现场未回应关键提问",
    summary: "录音还原了直播间对「送检批次」追问时的停顿与岔话，曝瓜网已定位到对应片段。",
    evidence: ["原声片段"],
    heat: "热度上升",
  },
];

export const chatThreads = [
  {
    id: "thread-a",
    title: "「假一赔十」承诺复盘群",
    parties: "供货方 · 运营(打码) · 场控",
    status: "已存证",
    meta: "2026-09-02 · 23:00 — 09-03 01:12",
    source: "单方流出",
    bubbles: [
      { side: "right", who: "运营 A", text: "这批就按大货来，别走那套备案流程，省时间。", time: "23:12" },
      { side: "left", who: "场控", text: "那万一被抽查对不上批次怎么办？", time: "23:14" },
      { side: "right", who: "运营 A", text: "查不到那么细，先冲量，后面再说。", time: "23:15" },
      { side: "left", who: "供货方", text: "行，那我按库存发，单子我这边备注一下。", time: "23:17" },
    ],
  },
  {
    id: "thread-b",
    title: "佣金分成 · 内部报价",
    parties: "招商 · 选品 · 品牌方(打码)",
    status: "已存证",
    meta: "2026-09-01 · 15:30 — 16:05",
    source: "双向流出",
    bubbles: [
      { side: "right", who: "招商", text: "给这个品按 35 报，品牌那边回扣我另谈。", time: "15:32" },
      { side: "left", who: "选品", text: "35？上个月同款才 18，翻倍了吧。", time: "15:34" },
      { side: "right", who: "招商", text: "分开报的，别写在同张表上。", time: "15:35" },
      { side: "left", who: "品牌方", text: "那直播间承诺别写死，话术我们自己来。", time: "16:00" },
    ],
  },
  {
    id: "thread-c",
    title: "后厨排班 · 值班群",
    parties: "店长 · 后厨(打码) · 采购",
    status: "比对中",
    meta: "2026-08-29 · 00:20 — 00:41",
    source: "员工单方",
    bubbles: [
      { side: "left", who: "店长", text: "今晚加班清库存，监控别留太久的记录。", time: "00:20" },
      { side: "right", who: "后厨", text: "那第二天营业用的料是现做还是？", time: "00:26" },
      { side: "left", who: "店长", text: "先顶一晚上，明早补上就行。", time: "00:29" },
      { side: "right", who: "采购", text: "日期我这边改了，别声张。", time: "00:41" },
    ],
  },
];

export const screenshotGallery = [
  {
    id: "shot-1",
    caption: "同款 SKU 批次号两段断档，中间缺 6 个连续号段",
    source: "发货底单 · 打码",
    image:
      "https://readdy.ai/api/search-image?query=glowing%20screen%20close%20up%20showing%20a%20long%20spreadsheet%20of%20product%20batch%20numbers%20with%20some%20rows%20highlighted%20in%20red%2C%20hands%20pointing%20at%20discrepancies%2C%20documentary%20evidence%20style%2C%20warm%20office%20light%2C%20investigative%20review%20of%20logistics%20records&width=640&height=640&seq=shot-batch-01&orientation=squarish",
  },
  {
    id: "shot-2",
    caption: "面单时间与平台发货接口存在 6 分钟时间戳差",
    source: "物流面单 · 打码",
    image:
      "https://readdy.ai/api/search-image?query=top%20view%20of%20stacked%20shipping%20labels%20and%20waybills%20on%20a%20desk%2C%20magnifying%20glass%20over%20timestamps%2C%20timestamp%20numbers%20circled%20in%20red%20ink%2C%20evidence%20archive%20photography%2C%20warm%20desk%20lamp%2C%20logistics%20investigation&width=640&height=640&seq=shot-face-01&orientation=squarish",
  },
  {
    id: "shot-3",
    caption: "报价表四档佣金，最大差距超过两倍",
    source: "选品报价表 · 打码",
    image:
      "https://readdy.ai/api/search-image?query=spreadsheet%20with%20four%20columns%20of%20commission%20tiers%20clearly%20different%20in%20amount%2C%20a%20phone%20flashlight%20beam%20shining%20on%20the%20numbers%2C%20messy%20desk%20with%20notes%2C%20documentary%20reporting%20style%2C%20warm%20and%20moody%20lighting&width=640&height=640&seq=shot-quote-01&orientation=squarish",
  },
  {
    id: "shot-4",
    caption: "直播排期与实际发货节点错位，同框底稿可比对",
    source: "后台排期 · 打码",
    image:
      "https://readdy.ai/api/search-image?query=computer%20monitor%20showing%20a%20live%20streaming%20schedule%20calendar%20with%20shipping%20dates%20overlaid%2C%20printed%20paper%20comparison%20beside%20the%20keyboard%2C%20warm%20room%20light%2C%20investigative%20evidence%20desk%20scene&width=640&height=640&seq=shot-live-01&orientation=squarish",
  },
  {
    id: "shot-5",
    caption: "考勤导出两次口径，后台水印时间相差 6 分钟",
    source: "后台截图 · 打码",
    image:
      "https://readdy.ai/api/search-image?query=two%20phone%20screens%20side%20by%20side%20showing%20attendance%20records%20with%20slightly%20different%20totals%2C%20timestamps%20highlighted%2C%20hands%20holding%20both%20devices%2C%20desk%20context%2C%20documentary%20style%2C%20soft%20warm%20lighting&width=640&height=640&seq=shot-kaoqin-01&orientation=squarish",
  },
  {
    id: "shot-6",
    caption: "后厨监控角与公开门面图做角度比对",
    source: "监控截图 · 打码",
    image:
      "https://readdy.ai/api/search-image?query=surveillance%20camera%20view%20of%20a%20kitchen%20at%20night%20compared%20to%20a%20bright%20daytime%20shot%20side%20by%20side%2C%20arrows%20marking%20similar%20stove%20and%20shelves%2C%20monitoring%20desk%20mood%2C%20warm%20light%2C%20evidence%20comparison&width=640&height=640&seq=shot-kitchen-01&orientation=squarish",
  },
];

export const audioReel = [
  {
    id: "aud-1",
    title: "返点数额 52 秒通话",
    duration: "00:52",
    source: "匿名投稿",
    level: "高清原声",
    description: "降噪转写已完成，关键金额与报价表逐项吻合。",
    marks: ["已转写", "待原声比对"],
  },
  {
    id: "aud-2",
    title: "成分表争议现场 40 秒",
    duration: "00:40",
    source: "现场录制",
    level: "现场原声",
    description: "还原直播间对送检批次的追问停顿，已定位对应片段。",
    marks: ["片段定位"],
  },
  {
    id: "aud-3",
    title: "压价话术 28 秒",
    duration: "00:28",
    source: "供应商提供",
    level: "高清原声",
    description: "疑似供货谈判压价录音，与报价单档位做交叉核对中。",
    marks: ["核验中"],
  },
  {
    id: "aud-4",
    title: "排班沟通 21 秒",
    duration: "00:21",
    source: "员工单方",
    level: "普通音质",
    description: "后厨加班沟通片段，配合监控截图时间线一起看更完整。",
    marks: ["待降噪"],
  },
];

export const hotComments = [
  {
    id: "c1",
    name: "半糖加冰",
    badge: "热门",
    time: "18:52",
    agree: 3280,
    text: "截图我两张张放大了对比过，批次号中间确实断档，不是 P 的。这波证据链是真的齐。",
  },
  {
    id: "c2",
    name: "吃瓜也要讲逻辑",
    badge: "置顶",
    time: "18:40",
    agree: 2911,
    text: "等对方原声出来再说，现在只凭单方录音下单结论有点早，建议保留吃瓜姿势。",
  },
  {
    id: "c3",
    name: "北北",
    badge: "热",
    time: "19:03",
    agree: 1765,
    text: "报价单那档差两倍，普通消费者根本不会往那想，这瓜值得细品。",
  },
  {
    id: "c4",
    name: "路过看戏",
    badge: "新",
    time: "19:20",
    agree: 982,
    text: "监控那个角度比对很有说服力，建议再补一张白天的营业照就能闭环了。",
  },
  {
    id: "c5",
    name: "柠檬不酸",
    badge: "热",
    time: "19:11",
    agree: 743,
    text: "考勤两套口径就差 6 分钟，谁后台谁说了算，唉。",
  },
];